import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Building2 } from 'lucide-react';

const AboutSection = ({ schoolInfo }) => {
  return (
    <section className="py-32 bg-white relative overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
          {/* Left: Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-block px-4 py-2 bg-purple-100 text-purple-700 rounded-full text-sm font-semibold mb-6">
              Tentang Projek
            </div>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              {schoolInfo.projectName}
            </h2>
            <div className="mb-4">
              <div className="inline-block px-4 py-2 bg-purple-600 text-white rounded-full text-sm font-semibold mb-2">
                {schoolInfo.theme}
              </div>
            </div>
            <div className="flex items-center gap-2 text-purple-600 mb-8">
              <MapPin className="w-5 h-5" />
              <span className="text-lg">{schoolInfo.location}</span>
            </div>
            <p className="text-xl text-gray-600 leading-relaxed mb-6">
              {schoolInfo.description}
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8 italic">
              <strong>Falsafah:</strong> {schoolInfo.philosophy}
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Building2 className="w-6 h-6 text-purple-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Tanah Wakaf 5 Ekar</h4>
                  <p className="text-gray-600">Dibina di atas tanah wakaf yang didaftarkan dengan Perbadanan Wakaf Selangor (PWS)</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Building2 className="w-6 h-6 text-purple-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Beroperasi Sejak 2015</h4>
                  <p className="text-gray-600">Telah melahirkan lebih 300 murid dengan pendidikan Islam integrasi</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right: Image grid */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="grid grid-cols-2 gap-4">
              <motion.div
                whileHover={{ scale: 1.03 }}
                className="col-span-2 h-72 rounded-3xl overflow-hidden shadow-xl"
              >
                <img
                  src="/images/kdu-building-front.png"
                  alt="Reka bentuk Kompleks Darul Ummah"
                  className="w-full h-full object-cover"
                />
              </motion.div>
              <motion.div
                whileHover={{ scale: 1.03 }}
                className="h-48 rounded-3xl overflow-hidden shadow-xl"
              >
                <img
                  src="/images/classroom-study.png"
                  alt="Pelajar dalam kelas"
                  className="w-full h-full object-cover"
                />
              </motion.div>
              <motion.div
                whileHover={{ scale: 1.03 }}
                className="h-48 rounded-3xl overflow-hidden bg-gradient-to-br from-purple-600 to-pink-500 shadow-xl flex items-center justify-center"
              >
                <div className="text-center text-white p-6">
                  <div className="text-4xl font-bold mb-2">{schoolInfo.totalGraduates}</div>
                  <div className="text-sm opacity-90">Murid Sejak 2015</div>
                </div>
              </motion.div>
            </div>

            {/* Decorative element */}
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
              className="absolute -top-10 -right-10 w-32 h-32 bg-purple-200/30 rounded-full blur-2xl -z-10"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;